<template>
  <div ref="$parallaxContainer" class="PastaParallaxWrapperCmp">
    <div ref="$parallaxWrapper" class="wrapper">
      <div
        class="parallax-bg-left"
        :style="{
          backgroundImage: `url(${$context.staticRoot}project/img/parallax-fusillo.png)`,
        }"
      />
      <slot />
      <div
        class="parallax-bg-right"
        :style="{
          backgroundImage: `url(${$context.staticRoot}project/img/parallax-rigatone.png)`,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PastaParallaxWrapperCmp',
  created() {
    this.resizeObserver = null;
  },
  mounted() {
    this.initObserver();
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    initObserver() {
      const container = this.$refs.$parallaxContainer;
      const wrapper = this.$refs.$parallaxWrapper;
      if (!container || !wrapper) return;

      this.resizeObserver = new ResizeObserver((entries) => {
        const style = window.getComputedStyle(container);
        const imgsHeight = parseFloat(
          style.getPropertyValue('--pasta-parallax-wrapper-imgs-height')
        );

        const currentWrapperHeight = entries[0].borderBoxSize[0].blockSize;

        container.style.setProperty(
          '--pasta-parallax-wrapper-race',
          `${currentWrapperHeight - imgsHeight}px`
        );
      });

      this.resizeObserver.observe(wrapper);
    },
    handleScroll() {
      const container = this.$refs.$parallaxContainer;
      const wrapper = this.$refs.$parallaxWrapper;
      if (!container || !wrapper) return;

      const rect = wrapper.getBoundingClientRect();
      const speedFactorImgRight = 0.5;
      const speedFactorImgLeft = 0.75;
      const progressImgRight =
        ((window.innerHeight - rect.top) / rect.height) * speedFactorImgRight;
      const progressImgLeft =
        ((window.innerHeight - rect.top) / rect.height) * speedFactorImgLeft;

      container.style.setProperty(
        '--pasta-parallax-wrapper-progress-img-right',
        Math.min(Math.max(progressImgRight, 0), 1).toFixed(4)
      );
      container.style.setProperty(
        '--pasta-parallax-wrapper-progress-img-left',
        Math.min(Math.max(progressImgLeft, 0), 1).toFixed(4)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.PastaParallaxWrapperCmp {
  --pasta-parallax-wrapper-race: 0;
  --pasta-parallax-wrapper-progress-img-right: 0;
  --pasta-parallax-wrapper-progress-img-left: 0;
  --pasta-parallax-wrapper-imgs-height: 96px;
  --pasta-parallax-wrapper-padding-block: 69px;
  --parallax-title-format-transition-duration: 0.2s;

  @include media-breakpoint-up(md) {
    --pasta-parallax-wrapper-imgs-height: 183px;
    --pasta-parallax-wrapper-padding-block: 144px;
  }

  @include media-breakpoint-up(lg) {
    --pasta-parallax-wrapper-padding-block: 132px;
  }

  @include media-breakpoint-up(xl) {
    --pasta-parallax-wrapper-padding-block: 78px;
  }

  .wrapper {
    position: relative;
    padding: var(--pasta-parallax-wrapper-padding-block) 0;
    isolation: isolate;

    .parallax-bg-right,
    .parallax-bg-left {
      position: absolute;
      height: var(--pasta-parallax-wrapper-imgs-height);
      background-size: cover;
      background-repeat: no-repeat;
      z-index: -1;
      will-change: transform;
      transition: transform var(--parallax-title-format-transition-duration)
        cubic-bezier(0.16, 1, 0.3, 1);
    }

    .parallax-bg-right {
      top: 0;
      right: 0;
      width: 118px;
      background-position: left center;
      transform: translateY(
        calc(
          0px + var(--pasta-parallax-wrapper-progress-img-right) *
            var(--pasta-parallax-wrapper-race)
        )
      );

      @include media-breakpoint-up(md) {
        width: 226px;
      }
    }

    .parallax-bg-left {
      bottom: 0;
      left: 0;
      width: 95px;
      background-position: right center;
      transform: translateY(
        calc(
          0px - var(--pasta-parallax-wrapper-progress-img-left) *
            var(--pasta-parallax-wrapper-race)
        )
      );

      @include media-breakpoint-up(md) {
        width: 287px;
      }
    }
  }
}
</style>
